<ui-alert>
  <ui-loading-spinner size="20" slot="icon" />
  <h2 slot="title">{{ 'cockpit.parseRequests.createdAlert.title' | transloco }}</h2>
  <p>
    {{ 'cockpit.parseRequests.createdAlert.description' | transloco }}
  </p>
  <div class="flex gap-2 mt-4">
    <ui-button mode="outlined" size="small" (click)="clickGoToDetails.emit()">
      {{ 'cockpit.parseRequests.createdAlert.buttonDetails' | transloco }}
    </ui-button>
    <ui-button mode="ghost" size="small" (click)="clickHide.emit()">
      {{ 'cockpit.parseRequests.createdAlert.buttonHide' | transloco }}
    </ui-button>
  </div>
</ui-alert>
